import { appMenuAdd, appMenuEdit, appMenuDel, appMenuFindAll } from "@/api/moudules/app";
import { menuCreateSave, menuDel, menuList } from "@/api/moudules/system";

/**
 * 菜单管理类别
 */
export enum E_MenuManageType {
    App = 'App',
    Browser = 'Browser'
}

export interface IMenuAPI {
    add
    edit
    delete
    list
}

export const MenuAPI = {
    [E_MenuManageType.App]: {
        'add': appMenuAdd,
        'edit': appMenuEdit,
        'delete': appMenuDel,
        'list': appMenuFindAll
    },
    [E_MenuManageType.Browser]: {
        'add': menuCreateSave,
        'edit': menuCreateSave,
        'delete': menuDel,
        'list': menuList
    },
}
